Vendd.Scripts.load(function () {

	var $wrapper = $('.x-payment-order');

	if ($wrapper.length < 1) return;

	$wrapper.each(function () {
		var paymentOrder = this;
		var $paymentOrder = $(paymentOrder);

		var $forms = $('.x-payment-order-form', $paymentOrder);

		if ($forms.length < 1) return;

		$forms.each(function () {
			var form = this;
			var $form = $(form);

			//var $submit = $('.js-submit-button', $paymentOrder);

			var $captcha = $('.recaptcha-wrapper', $form);
			var captchaId = $captcha.attr('id');
			var captchaWidgetId = undefined;

			// reCAPTCHA
			var captchaId = "paymentOrderCaptcha";
			var captchaWidgetId;
			var $captchaElement = $form.find("#" + captchaId);
			var $captchaContainer = $form.find('.recaptcha-container');
			var captchaEnabled = $captchaElement.length > 0 ? true : false;

			$.fn.validationEngine.validations.isPaymentOrderAmount = function (value) {
				var decimalSeparator = LhApp.Context.Currency.DecimalSeparator || '.';
				var nativeDecimalSeparator = '.';
				var numericLiteral = value.replace(decimalSeparator, nativeDecimalSeparator).trim();
				var numericRegExp = /^(?:\d+(?:\.\d*)?|\.(?:\d+)?)$/;

				return numericRegExp.test(numericLiteral);
			};

			var validationOptions = {
				'billingAddress.firstName': {
					required: 'firstname-required'
				},
				'billingAddress.lastName': {
					required: 'lastname-required'
				},
				'billingAddress.email': {
					required: 'email-required',
					isEmail: 'email-invalid'
				},
				'billingAddress.phone': {
					required: 'phone-required'
				},
				'billingAddress.mobile': {
					required: 'mobile-required'
				},
				'billingAddress.fax': {
					// required: 'fax-required'
				},
				'billingAddress.country': {
					required: 'country-required'
				},
				'billingAddress.address': {
					required: 'address-required'
				},
				'billingAddress.address2': {
					// required: 'address2-required'
				},
				'billingAddress.postCode': {
					required: 'postcode-required'
				},
				'billingAddress.city': {
					required: 'city-required'
				},
				'billingAddress.prefecture': {
					required: 'prefecture-required'
				},
				'preferredAmount': {
					required: 'amount-required',
					isPaymentOrderAmount: 'amount-invalid'
				},
				'paymentMethod': {
					checkboxRequired: 'paymentmethod-required'
				}
			};

			var validationEngine = $form.validationEngine(validationOptions).data('validationEngine');

			$form.on('submit', function (e) {
				form.updateJSONFieldValues();
				//form.logInputData();

				if (!validationEngine.validate() || !form.validateRecaptcha()) {
					form.scrollToError();
					e.preventDefault();
					e.stopPropagation();
					return;
				}

				form.loading(true);
			});

			$form.on('change', 'select[name], input[name][type="radio"]', function (e) {
				var $field = $(this);
				var name = $field.attr('name');
				validationEngine.validate(name);
			});

			$form.on('keyup', 'input[name], textarea[name]', function (e) {
				var $field = $(this);
				var name = $field.attr('name');
				validationEngine.validate(name);
			});

			$form.on('click', '.js-finloup-popup', function (e) {
				var externalUrl = "https://finloupms-bucket.s3.eu-central-1.amazonaws.com/externalpopup/";
				var content = LhApp.Context.Language === "el" ? "finloup_popup_el.html" : "finloup_popup.html";
				var parent = "?parent=" + window.document.location;
				var iframeUrl = externalUrl + content + parent;

				$.fancybox.open({
					src: iframeUrl,
					type: "iframe",
					toolbar: false,
					smallBtn: true,
					hash: null,
					baseClass: 'finloup-pop-up' 
				});
			});

			form.scrollToError = function () {
				var $formRowsWithError = $('.form-row.with-error', $form);

				if ($formRowsWithError.length > 0) {
					var $formRow = $formRowsWithError.first();
					var scrollOffsetY = $formRow.offset().top;

					$('html,body').animate({
						scrollTop: scrollOffsetY - 100
					}, 600);
				}

			};

			form.logInputData = function () {
				$form.find('input').each(function () {
					var $field = $(this);
					var name = $field.attr('name');
					var value = $field.val();

					console.log(name + ': "' + value + '"');
				});
			};

			form.initRecaptcha = function () {

				if (!captchaEnabled)
					return;

				var sitekey = $captchaElement.data("sitekey");
				if (sitekey) {
					captchaEnabled = true;
					captchaWidgetId = grecaptcha.render(captchaId, {
						'sitekey': sitekey,
						'callback': form.recaptchaCallback
					});
					//accessibility fix
					$('#g-recaptcha-response').attr('aria-label', 'recaptcha response');
				}
			};

			form.recaptchaCallback = function () {
				form.validateRecaptcha();
			};

			form.resetRecaptcha = function () {
				// Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
				// If a verify attempt has been made with a particular token, it cannot be used again. 
				// Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
				if (captchaEnabled)
					grecaptcha.reset(captchaWidgetId);
			};

			form.removeRecaptcha = function () {
				$captchaElement.remove();
			};

			form.validateRecaptcha = function () {
				if (!captchaEnabled)
					return true;

				formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

				var res = false;

				if (formData.reCaptchaCode) {
					$captchaContainer.find('.recaptcha-required').removeClass('error');
					res = true;
				}
				else {
					$captchaContainer.find('.recaptcha-required').addClass('error');
				}

				return res;
			};

			form.loading = function (loading) {
				$form.toggleClass('x-loading', loading);
			};

			form.updateJSONFieldValues = function () {
				$('.js-field-json-data', $form).each(function () {
					var $field = $(this);
					var name = $field.attr('name');
					var value = $field.val();
					var data = $field.data();
					//console.log('JSON data string[' + name + ']: "' + value + '"');
					value = value.length ? JSON.parse(value) : {};
					value = $.extend({}, value, data);
					value = JSON.stringify(data);
					$field.val(value);
				});
				$('.js-field-json-input', $form).each(function () {
					var $field = $(this);
					var fieldName = $field.attr('name');
					var fieldPrefix = fieldName + '.';
					var $inputs = $('input[name^="' + fieldPrefix + '"]', $form);
					var value = $field.val();
					//console.log('JSON input string[' + fieldName + ']: "' + value + '"');
					value = value.length ? JSON.parse(value) : {};
					$inputs.each(function () {
						var $input = $(this);
						var inputName = $input.attr('name').substr(fieldPrefix.length);
						var inputValue = $input.val();
						value[inputName] = inputValue;
					});
					value = JSON.stringify(value);
					$field.val(value);
				});
			};

			Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);
		});
	});
});